/*jshint devel:true */
/*jslint eqeq: true*/
/*jshint unused:false*/
import '../styles/main.scss';
import stickybits from "stickybits";
import login from "./login";
import dotsNav from "./dots";
import objectFitImages from "object-fit-images";
import { Dispatcher } from './helpers/dispatcher';
import { Dialog } from './helpers/dialog';
import { Spinner } from './helpers/spinner';
import { Feedback } from './helpers/feedback';
import { WebPushes } from './helpers/webpushes';
import { FavouritesList } from './helpers/favouriteslist';
import svgxuse from 'svgxuse';

window.dispatcher = new Dispatcher();
window.dispatcher.init();

const dialog = new Dialog(window.dispatcher);
const spinner = new Spinner(window.dispatcher);
const feedback = new Feedback(window.dispatcher, {
	url_send: typeof feedbackSendUrl === "undefined" ? "" : feedbackSendUrl,
	url_do_not_display: typeof feedbackDoNotDisplayUrl === "undefined" ? "" : feedbackDoNotDisplayUrl
});

const webPushes = new WebPushes(window.dispatcher, {});
const favouritestList = new FavouritesList(window.dispatcher, {});

// @codekit-prepend "../../node_modules/stickybits/dist/stickybits.js";

window.onload = function() {
	dialog.init();
	spinner.init();
	feedback.init();
    webPushes.init();
    favouritestList.init();
	// stickybits('.layout_mediatel #header-primary', {useStickyClasses: true});
	login();
	objectFitImages();
	var dotsExist = document.getElementsByClassName("dots-nav")[0];
	if (typeof(dotsExist) != 'undefined' && dotsExist != null) {
		dotsNav();
	}
	var htmlTag = document.getElementsByTagName("html")[0];
	htmlTag.classList.remove("preload");
	htmlTag.classList.add("loaded");
};
